import Heading from 'atoms/Heading';
import PropTypes from 'prop-types';

const timeLineTypes = {
  icon: 'icon',
  dot: 'dot',
};

const TimeLineList = ({ active, desc, visited, onClick, step, displayStep, totalSteps, compact }) => {
  return (
    <li
      className={`relative flex items-baseline gap-2 sm:gap-3 ${
        compact ? 'pb-4 last:pb-2' : 'pb-6 2xl:pb-[30px] last:pb-3'
      } before:absolute before:h-full before:w-[1px] before:bg-darkGrey-400 before:top-[10px] before:left-1 last:before:h-0 hover:cursor-pointer`}
      onClick={() => onClick(step)}
    >
      <div
        className={`rounded-full relative z-10 ${
          active
            ? 'h-[8px] w-[8px] xl:h-[11px] xl:w-[11px] bg-primary-900 ml-[0.5px] xl:-ml-[0.9px]'
            : 'w-[5px] h-[5px] xl:h-[7px] xl:w-[7px] bg-darkGrey-400 ml-0.5 xl:ml-[1.1px]'
        }`}
      ></div>
      <div>
        <p
          className={`${
            compact ? 'text-[11px] leading-snug' : 'text-xs 2xl:text-sm'
          } ${
            active
              ? 'text-primary-900 font-medium'
              : visited
              ? 'text-darkGrey-400'
              : 'text-darkGrey-400'
          }`}
        >
          {desc}
        </p>
      </div>
      <div
        className={`bg-primary-900 rounded-2xl text-white py-0.5 px-1.5 sm:py-1 sm:px-2 text-[9px] sm:text-xxs 2xl:text-xs text-center shrink-0 ${
          active ? 'block' : 'hidden'
        }`}
      >
        {displayStep || step} of {totalSteps || 5}
      </div>
    </li>
  );
};

const TimeLine = ({ timeLineListData, compact = false }) => {
  return (
    <div>
      <Heading
        type="h3"
        className={`text-black-800 font-semibold ${
          compact ? 'text-sm mb-3' : 'mb-5 2xl:mb-[30px]'
        }`}
      >
        {compact ? 'Setup steps' : 'Quick & Easy Setup'}
      </Heading>
      <ul>
        {timeLineListData.map(
          ({ active, desc, visited, step, displayStep, onClick }, index) => (
            <TimeLineList
              key={index}
              active={active}
              desc={desc}
              visited={visited}
              index={index}
              step={step}
              displayStep={displayStep || index + 1}
              totalSteps={timeLineListData.length}
              onClick={onClick}
              compact={compact}
            />
          )
        )}
      </ul>
    </div>
  );
};

TimeLine.propTypes = {
  types: PropTypes.array,
  timeLineListData: PropTypes.array,
  compact: PropTypes.bool,
};
export default TimeLine;
